<template>
  <KTCard :title="title" :subtitle="subTitle" :loading="loading">
    <template v-slot:body>
      <!-- area cargo form -->
      <b-form class="form" @submit.prevent="onSubmit">
        <!-- codigo -->
        <b-form-group
          label="Código Área Cargo *"
          label-for="codigo"
          description="Escriba el código"
        >
          <b-form-input
            id="codigo"
            v-model="areaCargo.id_mercado"
            type="text"
            required
            placeholder="Código Área Cargo"
          ></b-form-input>
        </b-form-group>
        <!-- literal -->
        <b-form-group
          label="Literal Área Cargo *"
          label-for="literal"
          description="Escriba el literal "
        >
          <b-form-input
            id="literal"
            v-model="areaCargo.descripcion"
            type="text"
            required
            placeholder="Literal Área Cargo"
          ></b-form-input>
        </b-form-group>
        <div class="d-flex justify-content-end span-3">
          <b-button class="mr-2" @click="cancel()">Cancelar</b-button>
          <b-button type="submit" variant="primary">Guardar</b-button>
        </div>
      </b-form>
    </template>
  </KTCard>
</template>

<script>
import KTCard from "@/view/content/Card.vue";
import {
  ADD_AREA_CARGO,
  EDIT_AREA_CARGO
} from "@/core/services/store/areasCargos.module";
import ApiService from "@/core/services/api.service";

export default {
  name: "area-cargo-add",
  components: {
    KTCard
  },
  data() {
    return {
      loading: false,
      areaCargo: {
        id_mercado: null,
        descripcion: "",
        actividad_mercado: 909
      }
    };
  },
  computed: {
    title() {
      return this.isEdit ? "Editar área cargo" : "Nueva área cargo";
    },
    subTitle() {
      return this.isEdit ? "Modifique los datos" : "Escriba todos los datos";
    },
    isEdit() {
      return this.$route.params.id !== undefined;
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.loading = true;
      const resp = await ApiService.get(
        `dic_mercados?id=${this.$route.params.id}`
      );
      this.areaCargo = resp.data.result[0];
      this.loading = false;
    }
  },
  methods: {
    cancel() {
      this.loading = false;
      this.$router.push("/lists/areas-cargos");
    },
    onSubmit() {
      this.loading = true;
      if (this.isEdit) {
        this.$store.dispatch(EDIT_AREA_CARGO, this.areaCargo).then(() => {
          this.cancel();
        });
      } else {
        this.$store.dispatch(ADD_AREA_CARGO, this.areaCargo).then(() => {
          this.cancel();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/pages/users/add";
</style>
